import { compose, withPropsOnChange } from 'recompose';
import { connect } from 'react-redux';
import withToggle from '../../../../../common/hoc/withToggle';
import { getItems, getItemsTotals } from '../../selectors';
import { clearBreakdown } from '../../actions';
import { getFiltersForMetrics, isDirty } from '../../../metrics/selectors';
import Criteria from '../../../metrics/Criteria';

const fetchData = fetchAction => compose(
  connect(
    state => ({
      filters: getFiltersForMetrics(state),
      data: getItems(state),
      totals: getItemsTotals(state),
    }),
    { fetchBreakdown: fetchAction }
  ),
  withPropsOnChange(
    ['isOn'],
    (props) => {
      if (props.isOn) {
        props.fetchBreakdown(new Criteria({
          fromDate: props.filters.fromDate,
          toDate: props.filters.toDate,
          barberFilter: props.filters.barberFilter,
          serviceCategoryFilter: props.filters.serviceCategories,
          productBrandFilter: props.filters.productBrands,
          barberId: props.filters.barberId,
          shopId: props.filters.shopId,
          brandId: props.filters.brandId,
          shopFilter: props.filters.shopFilter,
        }));
      }
    }
  )
);

const closeOnFilterChange = compose(
  connect(
    state => ({
      isDirty: isDirty(state),
    }),
    { clearBreakdown },
  ),
  withPropsOnChange(
    ['isDirty'],
    (props) => {
      props.off();
      props.clearBreakdown();
    },
  )
);

const TotalSalesBreakdownContainer = fetchAction => compose(
  withToggle(),
  fetchData(fetchAction),
  closeOnFilterChange,
);

export default TotalSalesBreakdownContainer;
